import React, { FC } from 'react';

import { i18n } from '../../../../shared/helpers/i18n';
import { OutgoingCallStatuses } from '../../types';
import css from './index.css';

interface Props {
    calleeName?: string;
    callStatus: OutgoingCallStatuses;
}

export const OutgoingCallStatus: FC<Props> = ({ calleeName, callStatus }) => {
    const callStatusDisplayNameMap: Record<OutgoingCallStatuses, string> = {
        [OutgoingCallStatuses.RINGING]: i18n('call', 'outgoing-call'),
        [OutgoingCallStatuses.CALLEE_CONNECTING]: i18n('call', 'call-connecting'),
    };

    return (
        <div className={css.OutgoingCallStatus}>
            <div className={css.OutgoingCallStatus__calleeName}>{calleeName}</div>
            <div className={css.OutgoingCallStatus__callStatus}>{callStatusDisplayNameMap[callStatus]}</div>
        </div>
    );
};
